<template>
  <vertical-modal width="tn" :visible="visible" @close="close"
                  header-title="جزئیات بار">
    <template #body v-if="payment_able?.order_id">
      <div class="tw-flex tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="qr-code" class="tw-align-middle tw-ml-4" />
          شناسه پرداختنی
        </div>
        <span class="tw-text-blue-dark-500">{{ payment_able?.id }}</span>
      </div>
      <div class="tw-flex tw-gap-28 tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="local-shipping" class="tw-align-middle tw-ml-4" />بار
        </div>

        <base-animated-text class="tw-text-blue-dark-500"
                            :text="(payment_able.order.order_id + ' - ' + (payment_able.order.load_type === 'warehouse_transfer' ? 'حواله انبار' : mixin.methods.get_fullname(payment_able.order.user)))"
                            max-length="20" />
      </div>
      <div class="tw-flex tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="barcode" class="tw-align-middle tw-ml-4" />
          شماره بارنامه
        </div>
        <span class="tw-text-blue-dark-500">{{ mixin.methods.getNumberBar(payment_able.order) || 'ندارد' }}</span>
      </div>
      <div class="tw-flex tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="home-max-dots" class="tw-align-middle tw-ml-4" />
          پلاک بار متصل
        </div>
        <span class="tw-text-blue-dark-500 ltr" v-html="mixin.methods.getPlateStr(payment_able.order.car) || 'ندارد'"></span>
      </div>
      <div class="tw-flex tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="event" class="tw-align-middle tw-ml-4" />
          تاریخ ایجاد
        </div>
        <span class="tw-text-blue-dark-500">{{ mixin.methods.to_jalali(payment_able.order.created_at) }}</span>
      </div>
      <div class="tw-flex tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="date-range" class="tw-align-middle tw-ml-4" />
          تاریخ بارگیری
        </div>
        <span class="tw-text-blue-dark-500">{{ payment_able.order.date_loaded ? mixin.methods.to_jalali(payment_able.order.date_loaded) : 'به زودی' }}</span>
      </div>
      <div class="tw-flex tw-justify-between tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-200 tw-py-3 tw-px-6">
        <div>
          <base-icon icon="event-available" class="tw-align-middle tw-ml-4" />
          تاریخ تخلیه
        </div>
        <span class="tw-text-blue-dark-500">{{ payment_able.order.date_disCharge ? mixin.methods.to_jalali(payment_able.order.date_disCharge) : 'به زودی' }}</span>
      </div>
    </template>
    <template #footer>
      <new-btn variant="outline"
               color="primary"
               @click="close">بستن
      </new-btn>
    </template>
  </vertical-modal>

</template>


<script setup>

import mixin from "@/mixin";
import VerticalModal from "@/components/base/VerticalModal.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import BaseAnimatedText from "@/components/base/BaseAnimatedText.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";


const props = defineProps({
  visible: { type: Boolean, default: false },
  payment_able: { type: Object, default: null },
})

const emit = defineEmits(['close'])

const close = () => {
  emit('close', true)
}
</script>


<style scoped>

</style>
